<template>
    <modal
        :name="'renovar-' + abonado.id"
        transition="pop-out"
        :width="1000"
        height="auto"
        :scrollable="true"
    >
        <div class="card m-0">
            <div class="card-header">
                <div class="row">
                    <div class="col-10">
                        <h2>Renovación rápida</h2>
                    </div>
                    <div class="col-2">
                        <button type="button" class="close" @click.prevent="close()">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>
            </div>
            <template v-if="paso === 1">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="card-body" v-if="(abonadoLocal.asiento) || abonadoLocal.plaza && plaza_disponible.libre">
                        <div class="row align-items-center">
                            <div class="col-3">
                                <p>NÚM. ABONADO ANTERIOR: <span class="text-primary h5">{{ abonadoLocal.n_abonado_antiguo }}</span></p>
                            </div>
                            <div class="col-3">
                                <p>NÚM. ABONADO NUEVO: <span class="text-primary h5">{{ abonadoLocal.n_abonado }}</span></p>
                            </div>
                            <div class="col-6">
                                <p v-if="abonadoLocal.asiento">
                                    ZONA:
                                    <br/>
                                    <span class="text-primary h5">{{ abonadoLocal.asiento.region }} / FILA: {{ abonadoLocal.asiento.row }} / BUTACA: {{ abonadoLocal.asiento.seat }}</span>
                                </p>
                                <p v-else-if="abonadoLocal.plaza">
                                    <span class="text-primary h5">
                                        {{ abonadoLocal.plaza.region_name ?? abonadoLocal.plaza.section_name }}</span> - FILA: <span class="text-primary h5 ">{{ abonadoLocal.plaza.fila }}</span> - ASIENTO: <span class="text-primary h5">{{ abonadoLocal.plaza.butaca }}
                                    </span>
                                </p>
                            </div>
                            <div class="col-12">
                                <strong>DATOS PERSONALES</strong>
                                <hr class="mt-1" />
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                        <FormInput 
                                            label="Nombre" 
                                            name="nombre" 
                                            id="nombre" 
                                            rules="required" 
                                            v-model="abonadoLocal.name" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Apellidos" 
                                            name="apellidos" 
                                            id="apellidos" 
                                            rules="required" 
                                            v-model="abonadoLocal.surnames" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Dni" 
                                            name="dni" 
                                            id="dni" 
                                            rules="required" 
                                            v-model="abonadoLocal.dni" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Fecha de nacimiento" 
                                            name="fecha_nacimiento" 
                                            id="fecha_nacimiento" 
                                            rules="required" 
                                            type="date" 
                                            min="1900-01-01" 
                                            v-model="abonadoLocal.fecha_nacimiento" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <FormInput 
                                            label="Email" 
                                            name="email" 
                                            id="email" 
                                            rules="required" 
                                            v-model="abonadoLocal.email" 
                                        />
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label>{{ $t('formularios.telefono') }}</label>
                                            <PhoneInput 
                                                :name="'telefono' + abonadoLocal.id" 
                                                :phone="abonadoLocal.telefono ?? null"
                                                :required="true" 
                                                @setNumber="(number) => { abonadoLocal.telefono = number;}"
                                                @validNumber="(valid) => { abonadoLocal.telefono_valido = valid;}"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <Paises
                                            @rellenarPais="rellenarPais"
                                            :errors="errors"
                                            v-on:selected="opt => { pais = opt; abonadoLocal.pais = opt.nombre; if (opt.nombre !== 'España') { provincia = null; abonadoLocal.provincia = ''; abonadoLocal.localidad = ''; }}"
                                        />
                                    </div>
                                    <div class="col-4" v-if="isSpain">
                                        <Provincias
                                            :errors="errors" :pais="pais.id"
                                            :provincia="abonadoLocal.provincia ?? ''"
                                            v-on:selected="opt => { provincia = opt; abonadoLocal.provincia = opt.nombre; }"
                                        />
                                    </div>
                                    <div class="col-4" v-if="isSpain">
                                        <Locations
                                            :desactivar="!provincia"
                                            :provincia="provincia"
                                            :errors="errors"
                                            :localidad="abonadoLocal.localidad ?? ''"
                                            v-on:selected="opt => { abonadoLocal.localidad = opt.nombre;}"
                                            :forceMultiselect="true"
                                        />
                                    </div>
                                    <div class="col-4 mt-3">
                                        <FormInput 
                                            label="Domicilio" 
                                            name="domicilio" 
                                            id="domicilio" 
                                            rules="required" 
                                            v-model="abonadoLocal.domicilio" 
                                        />
                                    </div>
                                    <template v-if="fields && fields.length > 0">
                                        <div v-for="(field, index) in fields" :key="index" :class="'col-4' + (field.type === 'textarea' ? ' col-lg-12' : '')">
                                            <FieldComponent 
                                                :field="field" 
                                                :desactivar="false" 
                                                v-model="abonadoLocal.properties[field.name]"
                                            />
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="col-12">
                                <strong>DATOS SOBRE EL ABONO</strong>
                                <hr class="mt-1" />
                            </div>
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="area">Tipo de abono</label>
                                            <ValidationProvider name="area" rules="required" v-slot="{ errors }">
                                                <select name="area" v-model="abonadoLocal.area" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <option value="undefined" disabled hidden>Seleccione un tipo de abono</option>
                                                    <template v-for="(precio, index) in getPrecioAbonado(abonadoLocal)">
                                                        <option :key="index" :value="precio" v-if="precio.renovacion">{{ precio.descripcion }}<span v-if="precio.renovacion"> - (Renovación)</span></option>
                                                    </template>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="precio">Precio</label>
                                            <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                                                <select name="precio" v-model="abonadoLocal.precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                                    <option value="undefined" disabled hidden>Seleccione un precio</option>
                                                    <option v-for="(descuento, index) in precios_abono" :key="index" :value="descuento">{{ descuento.label }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">
                                            <label for="metodo_pago">Método de pago</label>
                                            <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="metodo_pago" v-model="abonadoLocal.metodo_pago">
                                                    <option value="undefined" disabled hidden>Seleccione un método de pago</option>
                                                    <option v-for="(metodo, index) in metodos_pago" :key="index" :value="metodo">{{ metodo.nombre }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="permisos['venta.descuento']">
                                        <div class="form-group">
                                            <label for="descuento">Descuento en %</label>
                                            <ValidationProvider name="descuento_total" rules="required" v-slot="{ errors }">
                                                <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonadoLocal.descuento_aplicado" @change="aplicadoDescuento('porcentaje')" :disabled="disabled_descuento_porcentaje">
                                                    <option value="0">Sin descuento</option>
                                                    <option v-for="(descuento, index) in configuracion.descuento_aplicado" :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                                                </select>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4" v-if="permisos['venta.descuento']">
                                        <div class="form-group">
                                            <label for="nombre">Descuento en €</label>
                                            <ValidationProvider name="descuento en €" rules="required|double" v-slot="{ errors }">
                                                <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descuento en €" v-model="abonadoLocal.descuento_integro" @input="aplicadoDescuento('integro')" :disabled="disabled_descuento_integro" />
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Peña" id="penista" v-model="abonadoLocal.penista" />
                                    </div>
                                    <div class="col-4">
                                        <FormInput label="Empresa" id="empresa" v-model="abonadoLocal.empresa" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="IBAN" id="iban" rules="required" v-model="abonadoLocal.iban" />
                                    </div>
                                    <div v-if="is_domiciliado == true" class="col-4">
                                        <FormInput label="Titular de la cuenta" id="titular_cuenta" rules="required" v-model="abonadoLocal.titular_cuenta" />
                                    </div>
                                    <b-col cols="12" v-if="teatro.hash === 'J1fKG9AarPuPNJ5hwY0t'">
                                        <div class="mb-4 mt-4">
                                            <div class="checkbox-container">
                                                <input 
                                                    type="checkbox" 
                                                    name="renovacion-automatica"
                                                    id="renovacion-automatica" 
                                                    v-model="abonadoLocal.renovacion_automatica"
                                                />
                                                <label for="renovacion-automatica">
                                                    {{ $t('formularios.acepto_renovacion_automatica', { teatro: teatro.nombre }) }}, al marcar aceptas las <a href="#" @click.prevent="$modal.show('modalCondiciones')" class="underline">condiciones legales</a>
                                                </label>
                                            </div>
                                        </div>

                                        <ModalComponent 
                                            name="modalCondiciones"
                                            :title="$t('formularios.condiciones_renovacion_automatica') + ' ' + teatro.nombre"
                                            @close="$modal.hide('modalCondiciones')"
                                        >
                                            <div class="card-body">
                                                <div v-html="listaAbonados.renovacion_condiciones"></div>
                                            </div>
                                        </ModalComponent>
                                    </b-col>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="observaciones">Observaciones</label>
                                    <textarea class="form-control" rows="3" placeholder="Observaciones..." v-model="abonadoLocal.observaciones"></textarea>
                                </div>
                            </div>

                            <div class="col-12" v-if="abonadoLocal.metodo_pago && abonadoLocal.metodo_pago.id == 7">
                                <FormInput label="IBAN" name="IBAN" rules="required" v-model="abonadoLocal.iban" />
                                <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="abonadoLocal.titular_cuenta" />
                            </div>

                            <div v-if="listaAbonados.renovacion_automatica" >
                                <checkBoxRenovacion 
                                    :identificador="abonadoLocal.id"
                                    v-model="abonadoLocal.renovacion_automatica"
                                />
                            </div>

                            <div>
                                <DatosLegales 
                                    :datos="abonado" 
                                    :font_size="'16'" 
                                    :text_align="'left'" 
                                    :disabled="true" 
                                />
                            </div>
                            <div class="col-12">
                                <Button type="submit">Renovar</Button>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="abonadoLocal.plaza && !plaza_disponible.libre">
                        <div class="alert alert-danger w-75 mx-auto my-3 d-flex align-items-center justify-content-between" role="alert">
                            {{ plaza_disponible.message }}
                            <Button @click="cambiarAsiento">Cambiar asiento</Button>
                        </div>
                    </div>
                </ValidationObserver>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
            <template v-if="paso === 2">
                <SeleccionarParcelasComponent
                    v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'"
                    @continuar="(cart_id, datosParcelasseleccionados) => {
                        if(cart_id) {
                            parcelas_session_id = cart_id
                            datosParcelas = datosParcelasseleccionados;
                        };
                        paso = 3;
                    }"
                />

                <div v-if="compraConPlazos" class="card m-0 mt-4 tw:shadow-sm">
                    <div class="card-header tw:bg-blue-50 tw:border-b tw:border-blue-100">
                        <h4 class="card-title tw:m-0 tw:text-blue-900 tw:font-semibold">
                            <i class="fas fa-calendar-alt tw:mr-2"></i>Pago a plazos
                        </h4>
                    </div>

                    <div class="card-body tw:p-5">
                        <template v-if="loadingCalculo">
                            <div class="tw:space-y-3">
                                <SkeletonItem
                                    v-for="n in 3" :key="'plazo-skel-' + n"
                                    height="tw:h-8"
                                    customClass="tw:w-full tw:max-w-md tw:rounded tw:bg-gray-200"
                                />
                            </div>
                        </template>

                        <!-- Inline plazo picker (D1 final 2026-07-06).
                             Mirror of paso 3 picker; replaces AddPlazosComponent
                             nested modal. -->
                        <div v-else>
                            <p class="tw:text-sm tw:text-gray-600 tw:mb-4">
                                {{ $t('bases.texto_plazos') }}
                            </p>

                            <ValidationObserver
                                v-if="! (abonadoLocal.plazos && abonadoLocal.plazos_pendientes && abonadoLocal.plazos_pendientes.length > 0)"
                                tag="form"
                                ref="observerPlazoInline"
                                @submit.prevent="terminarPlazoInline"
                            >
                                <div class="tw:grid tw:grid-cols-1 md:tw:grid-cols-2 tw:gap-4 tw:mb-4">
                                    <div>
                                        <label class="tw:block tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-2">
                                            Cantidad de plazos
                                        </label>
                                        <ValidationProvider name="cuotas" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                v-model="plazoSelect"
                                                id="plazo-cuotas-inline-paso2"
                                                placeholder="Selecciona la cantidad de plazos"
                                                :options="cuotasOptionsInline"
                                                :show-labels="false"
                                                :max-height="200"
                                                class="tw:w-full"
                                            />
                                            <span v-if="errors[0]" class="tw:text-red-600 tw:text-xs tw:mt-1 tw:block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>

                                    <div v-if="abonadoLocal.area.frecuencias && abonadoLocal.area.frecuencias.length > 0">
                                        <label class="tw:block tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-2">
                                            Frecuencia de pago
                                        </label>
                                        <ValidationProvider name="frecuencia" rules="required" v-slot="{ errors }">
                                            <multiselect
                                                v-model="frecuenciaSelect"
                                                id="plazo-frecuencia-inline-paso2"
                                                label="frecuencia_formatted"
                                                track-by="id"
                                                placeholder="Selecciona la frecuencia"
                                                :options="abonadoLocal.area.frecuencias"
                                                :show-labels="false"
                                                :max-height="200"
                                                class="tw:w-full"
                                            />
                                            <span v-if="errors[0]" class="tw:text-red-600 tw:text-xs tw:mt-1 tw:block">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                </div>

                                <b-alert
                                    v-if="abonadoLocal.precio && abonadoLocal.precio.price_management && !abonadoLocal.precio.price_management_interno"
                                    variant="info"
                                    class="tw:text-sm tw:mb-4"
                                    show
                                >
                                    {{ $t('bases.aviso_gd', { gd: abonadoLocal.precio.price_management }) }}
                                </b-alert>

                                <b-alert
                                    v-if="errorPlazos"
                                    variant="danger"
                                    class="tw:text-sm tw:mb-4"
                                    show
                                >
                                    No es posible fraccionar los plazos de pago con fecha superior a fecha {{ teatro.fecha_limite_plazos }}
                                </b-alert>

                                <div class="tw:flex tw:justify-end tw:gap-2 tw:pt-2 tw:border-t tw:border-gray-100">
                                    <Button
                                        type="button"
                                        customClass="btn btn-primary"
                                        @click.prevent="terminarPlazoInline"
                                    >
                                        <i class="fas fa-calculator tw:mr-2"></i>Calcular plazos
                                    </Button>
                                </div>
                            </ValidationObserver>

                            <div v-else>
                                <div class="tw:bg-gray-50 tw:rounded-md tw:p-4 tw:mb-4">
                                    <h5 class="tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-3 tw:uppercase tw:tracking-wide">
                                        Plan de pago calculado
                                    </h5>
                                    <ul class="tw:divide-y tw:divide-gray-200">
                                        <li
                                            v-for="(plazo, key) in abonadoLocal.plazos_pendientes"
                                            :key="'plazo-inline-paso2-' + key"
                                            class="tw:flex tw:justify-between tw:items-center tw:py-2 tw:text-sm"
                                        >
                                            <span class="tw:font-medium tw:text-gray-700">
                                                <i class="fas fa-circle tw:text-blue-500 tw:text-xs tw:mr-2"></i>
                                                Plazo {{ key + 1 }}
                                                <span v-if="plazo.informacion" class="tw:text-gray-500 tw:text-xs tw:ml-2">
                                                    ({{ plazo.informacion }})
                                                </span>
                                            </span>
                                            <span class="tw:font-semibold tw:text-gray-900">
                                                {{ (plazo.importe + plazo.gastos) | formatear_precio }}
                                            </span>
                                        </li>
                                    </ul>
                                </div>

                                <div class="tw:flex tw:justify-end tw:gap-2 tw:pt-2 tw:border-t tw:border-gray-100">
                                    <Button
                                        type="button"
                                        customClass="btn btn-outline-secondary"
                                        @click.prevent="importeCompleto"
                                    >
                                        <i class="fas fa-times tw:mr-2"></i>Importe completo
                                    </Button>
                                    <Button
                                        type="button"
                                        customClass="btn btn-outline-primary"
                                        @click.prevent="editarPlazos"
                                    >
                                        <i class="fas fa-edit tw:mr-2"></i>Modificar plazos
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="paso === 3">
                <div class="card-body">
                    <div class="row">
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>DATOS DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-user"></i></span> <strong> {{ abonadoLocal.name }} {{ abonadoLocal.surnames }}</strong></span>
                                    <hr/>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-id-card"></i></span> <strong> {{ abonadoLocal.dni }}</strong></span>
                                    <hr/>
                                </div>
                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-envelope"></i></span> <strong> {{ abonadoLocal.email }}</strong></span>
                                    <hr/>
                                </div>

                                <div class="col-12">
                                    <span class="h5"><span class="text-primary"><i class="fas fa-phone"></i></span> <strong> {{ abonadoLocal.telefono }}</strong></span>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="row">
                                <div class="col-12">
                                    <strong>INFORMACIÓN DEL ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <template v-if="abonadoLocal.asiento">
                                        <span class="h4 text-uppercase text-primary"><strong>{{ abonadoLocal.asiento.region }}</strong></span>
                                        <span class="h4 text-uppercase"><strong>/ FILA: {{ abonadoLocal.asiento.row }}</strong></span>
                                        <span class="h4 text-uppercase"><strong>/ BUTACA: {{ abonadoLocal.asiento.seat }}</strong></span>                                            
                                    </template>
                                    <template v-else-if="abonadoLocal.plaza">
                                        <span class="h4 text-uppercase" v-if="abonadoLocal.plaza.region_name">{{ abonadoLocal.plaza.region_name }}</span>
                                        <span class="h4 text-uppercase"> / FILA: {{ abonadoLocal.plaza.fila }}</span>
                                        <span class="h4 text-uppercase"> / BUTACA: {{ abonadoLocal.plaza.butaca }}</span>
                                    </template>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>TIPO DE ABONO</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonadoLocal.precio.descripcion }}</strong></span>
                                </div>
                                <div class="col-12 mt-3">
                                    <strong>FORMA DE PAGO SELECCIONADA</strong>
                                </div>
                                <div class="col-12">
                                    <span class="h4 text-uppercase"><strong>{{ abonadoLocal.metodo_pago.nombre }}</strong></span>
                                </div>

                                <div v-if="compraConPlazos" class="card m-0 mt-4 tw:shadow-sm">
                                    <div class="card-header tw:bg-blue-50 tw:border-b tw:border-blue-100">
                                        <h4 class="card-title tw:m-0 tw:text-blue-900 tw:font-semibold">
                                            <i class="fas fa-calendar-alt tw:mr-2"></i>Pago a plazos
                                        </h4>
                                    </div>

                                    <div class="card-body tw:p-5">
                                        <template v-if="loadingCalculo">
                                            <div class="tw:space-y-3">
                                                <SkeletonItem
                                                    v-for="n in 3" :key="'plazo-skel-paso3-' + n"
                                                    height="tw:h-8"
                                                    customClass="tw:w-full tw:max-w-md tw:rounded tw:bg-gray-200"
                                                />
                                            </div>
                                        </template>

                                        <!-- Inline plazo picker (D1 final 2026-07-06).
                                             Replaces AddPlazosComponent's nested <b-modal>
                                             which rendered behind the parent vue-js-modal.
                                             Here: taquillero selects n_plazos + frecuencia
                                             directly in the wizard, no popup. -->
                                        <div v-else>
                                            <p class="tw:text-sm tw:text-gray-600 tw:mb-4">
                                                {{ $t('bases.texto_plazos') }}
                                            </p>

                                            <ValidationObserver
                                                v-if="! (abonadoLocal.plazos && abonadoLocal.plazos_pendientes && abonadoLocal.plazos_pendientes.length > 0)"
                                                tag="form"
                                                ref="observerPlazoInline"
                                                @submit.prevent="terminarPlazoInline"
                                            >
                                                <div class="tw:grid tw:grid-cols-1 md:tw:grid-cols-2 tw:gap-4 tw:mb-4">
                                                    <div>
                                                        <label class="tw:block tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-2">
                                                            Cantidad de plazos
                                                        </label>
                                                        <ValidationProvider
                                                            name="cuotas"
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <multiselect
                                                                v-model="plazoSelect"
                                                                id="plazo-cuotas-inline"
                                                                placeholder="Selecciona la cantidad de plazos"
                                                                :options="cuotasOptionsInline"
                                                                :show-labels="false"
                                                                :max-height="200"
                                                                class="tw:w-full"
                                                            />
                                                            <span v-if="errors[0]" class="tw:text-red-600 tw:text-xs tw:mt-1 tw:block">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>

                                                    <div v-if="abonadoLocal.area.frecuencias && abonadoLocal.area.frecuencias.length > 0">
                                                        <label class="tw:block tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-2">
                                                            Frecuencia de pago
                                                        </label>
                                                        <ValidationProvider
                                                            name="frecuencia"
                                                            rules="required"
                                                            v-slot="{ errors }"
                                                        >
                                                            <multiselect
                                                                v-model="frecuenciaSelect"
                                                                id="plazo-frecuencia-inline"
                                                                label="frecuencia_formatted"
                                                                track-by="id"
                                                                placeholder="Selecciona la frecuencia"
                                                                :options="abonadoLocal.area.frecuencias"
                                                                :show-labels="false"
                                                                :max-height="200"
                                                                class="tw:w-full"
                                                            />
                                                            <span v-if="errors[0]" class="tw:text-red-600 tw:text-xs tw:mt-1 tw:block">{{ errors[0] }}</span>
                                                        </ValidationProvider>
                                                    </div>
                                                </div>

                                                <b-alert
                                                    v-if="abonadoLocal.precio && abonadoLocal.precio.price_management && !abonadoLocal.precio.price_management_interno"
                                                    variant="info"
                                                    class="tw:text-sm tw:mb-4"
                                                    show
                                                >
                                                    {{ $t('bases.aviso_gd', { gd: abonadoLocal.precio.price_management }) }}
                                                </b-alert>

                                                <b-alert
                                                    v-if="errorPlazos"
                                                    variant="danger"
                                                    class="tw:text-sm tw:mb-4"
                                                    show
                                                >
                                                    No es posible fraccionar los plazos de pago con fecha superior a fecha {{ teatro.fecha_limite_plazos }}
                                                </b-alert>

                                                <div class="tw:flex tw:justify-end tw:gap-2 tw:pt-2 tw:border-t tw:border-gray-100">
                                                    <Button
                                                        type="button"
                                                        customClass="btn btn-primary"
                                                        @click.prevent="terminarPlazoInline"
                                                    >
                                                        <i class="fas fa-calculator tw:mr-2"></i>Calcular plazos
                                                    </Button>
                                                </div>
                                            </ValidationObserver>

                                            <!-- Resumen inline: shown after plazos are computed -->
                                            <div v-else>
                                                <div class="tw:bg-gray-50 tw:rounded-md tw:p-4 tw:mb-4">
                                                    <h5 class="tw:text-sm tw:font-semibold tw:text-gray-700 tw:mb-3 tw:uppercase tw:tracking-wide">
                                                        Plan de pago calculado
                                                    </h5>
                                                    <ul class="tw:divide-y tw:divide-gray-200">
                                                        <li
                                                            v-for="(plazo, key) in abonadoLocal.plazos_pendientes"
                                                            :key="'plazo-inline-' + key"
                                                            class="tw:flex tw:justify-between tw:items-center tw:py-2 tw:text-sm"
                                                        >
                                                            <span class="tw:font-medium tw:text-gray-700">
                                                                <i class="fas fa-circle tw:text-blue-500 tw:text-xs tw:mr-2"></i>
                                                                Plazo {{ key + 1 }}
                                                                <span v-if="plazo.informacion" class="tw:text-gray-500 tw:text-xs tw:ml-2">
                                                                    ({{ plazo.informacion }})
                                                                </span>
                                                            </span>
                                                            <span class="tw:font-semibold tw:text-gray-900">
                                                                {{ (plazo.importe + plazo.gastos) | formatear_precio }}
                                                            </span>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="tw:flex tw:justify-end tw:gap-2 tw:pt-2 tw:border-t tw:border-gray-100">
                                                    <Button
                                                        type="button"
                                                        customClass="btn btn-outline-secondary"
                                                        @click.prevent="importeCompleto"
                                                    >
                                                        <i class="fas fa-times tw:mr-2"></i>Importe completo
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        customClass="btn btn-outline-primary"
                                                        @click.prevent="editarPlazos"
                                                    >
                                                        <i class="fas fa-edit tw:mr-2"></i>Modificar plazos
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12 mt-3">
                                    <template v-if="! abonadoLocal.plazos">
                                        <strong>PRECIO ABONO <span> <span v-if="abonadoLocal.descuento_aplicado > 0" class="text-primary">(DESCUENTO DEL {{ abonadoLocal.descuento_aplicado }}%)</span></span></strong>
                                    </template>
                                    <template v-else>
                                        <div class="col-12 mt-3">
                                            <strong>PLAZOS:</strong>
                                        </div>
                                        <div class="col-12">
                                            <ul>
                                                <li v-for="(plazo, key) in abonadoLocal.plazos_pendientes" :key="key">
                                                    <template v-if="plazo.gastos_internos == 0">
                                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}
                                                    </template>
                                                    <template v-else>
                                                        Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                                    </template>                                            
                                                </li>                               
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                                <div class="col-12">
                                    <span class="h4" v-if="abonadoLocal.descuento_aplicado > 0 || es_invitacion">
                                        <del class="text-muted">
                                            <strong>
                                                {{ abonadoLocal.precio.precio_total_taquilla | formatear_precio }}
                                            </strong>
                                        </del>
                                        <span v-if="es_invitacion" class="h5 ml-2 align-middle text-success text-uppercase font-weight-bold">
                                            <i class="fas fa-gift mr-1"></i>Invitación
                                        </span>
                                    </span>
                                    <template v-if="! abonadoLocal.plazos">
                                        <strong>TOTAL:</strong><span class="h1"> <del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong :class="es_invitacion ? 'text-success' : ''"> {{ (es_invitacion ? 0 : total) | formatear_precio }}</strong></span>
                                    </template>
                                    <template v-else>
                                        <strong>TOTAL:</strong><span class="h1"><del class="" v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong :class="es_invitacion ? 'text-success' : ''"> {{ (es_invitacion ? 0 : total) | formatear_precio }}</strong></span>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <hr/>
                        </div>

                        <template v-if="teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t'">
                            <div v-for="(parcela, index) in datosParcelas" :key="parcela.id" class="col-12 bg-light p-2 m-3">
                                <h3>
                                    <strong class="d-flex align-items-center">
                                        <span class="text-primary pr-4">PARCELA {{ ++index }}. </span>
                                        <span class="pr-4"><strong> Parcela Nº</strong> {{ parcela.numero }} </span>
                                        <div class="pr-4">
                                            PRECIO: <span>{{ parseFloat(parcela.precioSeleccionado.precio + (!parcela.precioSeleccionado.price_management_interno ? parcela.precioSeleccionado.price_management : 0)) | formatear_precio }}</span>
                                        </div>
                                    </strong>
                                </h3>
                            </div>
                        </template>

                        <div class="col-12" v-if="!loading && teatro.activar_referidos && abonadoLocal.importe_monedero > 0">
                            <Button class="float-left" @click.prevent="isDescuentoMonedero = !isDescuentoMonedero">Descuento monedero</Button>
                        </div>

                        <div class="col-12" v-if="!loading && teatro.activar_referidos && abonadoLocal.importe_monedero > 0">
                            <SaldoMonederoComponent
                                v-if="isDescuentoMonedero"
                                :saldo_disponible="abonadoLocal.importe_monedero"
                                :importe="total"
                                :descuento_aplicado="abonadoLocal.descuento_monedero === undefined ? 0 : parseFloat(abonadoLocal.descuento_monedero)"
                                @confirmado="descuentoConfirmado"
                                @cancelar="cancelarDescuento"
                            />
                        </div>

                        <div class="col-12" v-if="!loading">
                            <template v-if="! abonadoLocal.plazos">
                                <strong>TOTAL:</strong><span class="h1"><del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong :class="es_invitacion ? 'text-success' : ''"> {{ (es_invitacion ? 0 : total + importeTotalParcelas) | formatear_precio }}</strong></span>
                            </template>
                            <template v-else>
                                <strong>TOTAL:</strong><span class="h1"><del v-if="totalSinDescuentoMonedero">{{totalSinDescuentoMonedero | formatear_precio}}</del> <strong :class="es_invitacion ? 'text-success' : ''"> {{ (es_invitacion ? 0 : total + importeTotalParcelas) | formatear_precio }}</strong></span>
                            </template>

                            <template v-if="!finalizado">
                                <Button class="float-right" @click.prevent="finalizarCompra()">COMPRAR</Button>
                                <Button
                                    class="float-right mr-3"
                                    @click.prevent="editarCompra"
                                >
                                    EDITAR
                                </Button>
                            </template>
                            <template v-if="error">
                                <div class="alert alert-danger alert-dismissible mt-3">
                                    <h5><i class="icon fas fa-exclamation-triangle mt-2"></i>{{ error }}</h5>
                                </div>
                            </template>
                            <div class="alert alert-success alert-dismissible mt-3" v-if="finalizado && error == null">
                                <h5>
                                    <i class="icon fas fa-check mt-2"></i>
                                    {{ mensaje }}
                                    <Button :href="url_imprimir" class="btn-large float-right" target="_blank">Imprimir abono</Button>
                                    <Button :href="url_factura + '&tid=' + configuracion.hash_teatro" class="btn-large float-right mr-2" target="blank_">Imprimir recibo</Button>
                                    <Button v-if="url_parcelas" :href="url_parcelas" class="btn-large float-right mr-2" target="blank_">Imprimir parcelas</Button>
                                </h5>
                            </div>
                        </div>
                        <div v-else class="col-12" style="height: 100px">
                            <LoaderComponent />
                        </div>
                    </div>
                </div>
                <div class="card-footer text-right">
                    <Button type="button" name="button" @click.prevent="close()">CERRAR</Button>
                </div>
            </template>
        </div>
    </modal>
</template>

<script>
    import SaldoMonederoComponent from '@/modules/front/abonos/SaldoMonedero.vue';
    import DatosLegales from './DatosLegales.vue';
    import FieldComponent from '@/components/common/FieldComponent';
    import SeleccionarParcelasComponent from '../../abonos/renovacion/rapida/SeleccionarParcelasComponent.vue';
    import PhoneInput from '@/components/common/PhoneInput.vue';
    import Paises from "../../../common/forms/Paises";
    import Provincias from "../../../common/forms/Provincias";
    import Locations from "../../../common/forms/Locations";
    import checkBoxRenovacion from '../../../common/checkBoxRenovacion.vue';
    import { esDescuentoValidoParaEdad } from '@/composables/common/useFiltrarDescuentosPorEdad';
    import { useRenovacionRapidaPlazos } from '@/composables/admin/abonados/useRenovacionRapidaPlazos';
    import { SkeletonItem } from '@/modules/admin/ui/skeleton';
    import { getCurrentInstance } from 'vue';

    export default {
        props: {
            abonado: {
                type: Object,
                required: true
            },
            precios: {
                type: Array,
                required: true
            }
        },
        setup() {
            const instance = getCurrentInstance();
            return useRenovacionRapidaPlazos({
                getAbonadoLocal: () => instance.proxy.abonadoLocal,
                getTeatro: () => instance.proxy.$store.getters.getTeatro,
            });
        },
        data() {
            return {
                metodos_pago: null,
                continuar: false,
                finalizado: false,
                loading: false,
                url_imprimir: null,
                url_factura: null,
                url_parcelas: null,
                mensaje: null,
                error: null,
                isDescuentoMonedero: false,
                total: 0,
                totalSinDescuentoMonedero: 0,
                preciosFiltered: null,
                abonadoLocal: {...this.abonado},
                paso: 1,
                datosParcelas: null,
                parcelas_session_id: null,
                disabled_descuento_integro: false,
                disabled_descuento_porcentaje: false,
                pais: null,
                provincia: null,
                errors: [],
                // Inline plazo picker state (D1 final 2026-07-06). Replaces
                // AddPlazosComponent's nested <b-modal>. Visibility of the
                // picker vs resumen is data-driven (abonadoLocal.plazos +
                // plazos_pendientes), not a flag.
                plazoSelect: null,
                frecuenciaSelect: null,
            }
        },
        created() {
            this.abonadoLocal.properties = {};
            this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice();

            if (this.abonadoLocal.asiento) {
                this.preciosFiltered = this.precios.filter(precio => precio.renovacion);
                this.preciosFiltered = this.preciosFiltered.filter(precio => {
                    if (precio.zonas_ids.length > 0) {
                        return precio.zonas_ids.includes(this.abonadoLocal.asiento.region_id);                    
                    } return false;
                })
            } else if (this.abonadoLocal.plaza) {
                if (this.abonadoLocal.plaza.precios.length > 0) {
                    const preciosRenovacion = this.abonadoLocal.plaza.precios.filter(precio => precio.renovacion)
                    this.preciosFiltered = preciosRenovacion
                        .filter(precio => precio.descuentos && precio.descuentos.length > 0)
                        .map(precio => ({
                            ...precio,
                            descuentos: precio.descuentos.map(descuento => ({
                                ...descuento,
                                label: `${descuento.descripcion} - (${descuento.price_management_interno_taquilla ? descuento.precio : descuento.precio + descuento.price_management_taquilla}€)`
                            }))
                        }));
                }
            }

            if (this.preciosFiltered && this.preciosFiltered.length === 1) {
                this.abonadoLocal.area = this.preciosFiltered[0];

                if (this.abonadoLocal.area.descuentos && this.abonadoLocal.area.descuentos.length === 1) {
                    this.abonadoLocal.precio = this.abonadoLocal.area.descuentos[0];
                }
            }

            this.abonadoLocal.descuento_aplicado = 0;
            this.abonadoLocal.descuento_integro = 0;

            this.borrarMetodoDePago(this.metodos_pago, 5);
            this.borrarMetodoDePago(this.metodos_pago, 8);

            if (this.abonadoLocal.area && this.abonadoLocal.precio) {
                const descuentos = this.abonadoLocal.area.descuentos || [];
                const pertenece = descuentos.some(d => d.id === this.abonadoLocal.precio.id);
                if (!pertenece) {
                    this.$set(this.abonadoLocal, 'precio', null);
                }
            }
        },
        watch: {
            provincia(newVal, oldVal) {
                if (oldVal && newVal && oldVal.id !== newVal.id) {
                    this.abonadoLocal.localidad = '';
                }
            },
            'abonadoLocal.area': function(newArea) {
                if (!this.abonadoLocal.precio) return;
                const descuentos = newArea?.descuentos || [];
                const pertenece = descuentos.some(d => d.id === this.abonadoLocal.precio.id);
                if (!pertenece) {
                    this.$set(this.abonadoLocal, 'precio', null);
                }
            },
        },
        computed: {
            // Inline plazo picker (D1 final 2026-07-06)
            cuotasOptionsInline() {
                const area = this.abonadoLocal.area || {};
                const min = area.min_cantidad_plazos || 1;
                const max = area.max_cantidad_plazos || min;
                const opts = [];
                for (let i = min; i <= max; i++) opts.push(i);
                return opts;
            },
            lista_id() {
                return this.$store.getters.getListaId;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            precios_abono() {
                return this.abonadoLocal.area ? this.abonadoLocal.area.descuentos : [];
            },
            is_domiciliado() {
                if (!this.abonadoLocal.metodo_pago) {
                    return false
                }
                return this.abonadoLocal.metodo_pago.id == 5 ? true : false;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            permisos() {
                return this.$store.getters.getPermisos;
            },
            plaza_disponible() {
                if(this.abonadoLocal.plaza) {
                    const response = {
                        libre: false,
                        message: ''
                    }
        
                    if (!this.abonadoLocal.plaza.libre) {
                        const ocupada = this.abonadoLocal.plaza.ocupada;
        
                        if (this.abonadoLocal.plaza.info_ocupada.numero_abonado === this.abonadoLocal.n_abonado) {
                            response.libre = true;
                        } else {
                            response.message = 'Butaca ocupada por otro usuario';
                        }
        
                        if (ocupada.sesion) {
                            response.message = 'Butaca en sesión';
                        } else if (ocupada.evento_venta) {
                            response.message = 'Butaca vendida en un evento';
                        } else if (ocupada.evento_bloqueo) {
                            response.message = 'Butaca bloqueada en un evento';
                        } else if (ocupada.evento_sesion) {
                            response.message = 'Butaca en sesión en un evento';
                        }
                    } else {
                        response.libre = true;
                    }
        
                    return response;
                }

                return {
                    libre: false
                };
            },
            fields() {
                return this.$store.getters.getListaAbonados.fields;
            },
            listaAbonados() {
                return this.$store.getters.getListaAbonados;
            },
            importeTotalParcelas() {
                if (this.teatro.hash === 'J1fKG9AarPuPNJ5hwY0t') {
                    return 0;
                }
                if(! this.datosParcelas || !this.datosParcelas.length) {
                    return 0;
                }

                let total = 0;

                this.datosParcelas.forEach(parcela => {
                    total += parcela.precioSeleccionado.precio;

                    if(! parcela.precioSeleccionado.price_management_interno) {
                        total += parcela.precioSeleccionado.price_management;
                    }
                });

                return total;
            },
            isSpain() {
                return this.pais && this.pais.nombre === 'España';
            },
            es_invitacion() {
                return this.abonadoLocal?.metodo_pago?.es_invitacion === 1;
            },
        },
        methods: {
            // Inline plazo picker buttons (paso 2 + paso 3 resumen). The
            // composable's resetPlazos() handles abonado.plazos /
            // plazos_pendientes; these wrappers also manage the
            // component-local plazoSelect / frecuenciaSelect so the
            // taquillero sees the right UX:
            //   - "Modificar plazos": keep selection so they can re-pick.
            //   - "Importe completo": clear selection so the picker re-opens.
            // Wrapped in methods (not inline arrow functions in template)
            // because Vue 2's template compiler captures `this` from
            // the lexical scope, not the component instance — that
            // produced "can't access property 'resetPlazos', _this is null"
            // at click time.
            editarPlazos() {
                this.resetPlazos();
            },
            importeCompleto() {
                this.resetPlazos();
                this.plazoSelect = null;
                this.frecuenciaSelect = null;
            },
            // Editar button (paso 3): go back to paso 1 or paso 2 depending
            // on whether parcelas are enabled. Extracted from inline
            // arrow function in template to avoid the Vue 2 _this-is-null
            // error (the inline arrow function captured `this` from the
            // render function's lexical scope, not the component instance).
            // Also fixes a pre-existing bug: original code assigned to
            // `datosParcelas` and `paso` without `this.`, so the reactive
            // state was never actually updated.
            editarCompra() {
                this.resetPlazos();
                if (this.listaAbonados.activar_parcelas && this.teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t') {
                    this.datosParcelas = null;
                    this.borrarSesionParcelas(this.abonadoLocal.parcelas_session_id);
                    this.paso = 2;
                } else {
                    this.paso = 1;
                }
            },
            // Inline plazo picker continuation handler (D1 final 2026-07-06).
            // Upfront validation so missing inputs surface as toasts.
            async terminarPlazoInline() {
                // Validate plazoSelect
                if (this.plazoSelect === null || this.plazoSelect === undefined) {
                    if (this.$toast && this.$toast.error) {
                        this.$toast.error('Selecciona la cantidad de plazos');
                    }
                    return;
                }

                // Validate area + frecuencias
                const area = this.abonadoLocal.area || {};
                const frecuencias = area.frecuencias || [];
                if (frecuencias.length === 0) {
                    if (this.$toast && this.$toast.error) {
                        this.$toast.error('No hay frecuencias configuradas para este tipo de abono');
                    }
                    return;
                }
                if (!this.frecuenciaSelect || !this.frecuenciaSelect.id) {
                    if (this.$toast && this.$toast.error) {
                        this.$toast.error('Selecciona la frecuencia de pago');
                    }
                    return;
                }

                // Dispatch via existing wrapper (composable's calcularPlazos).
                // The composable already toasts on errors and never re-throws,
                // so no try/catch is needed here.
                await this.solicitarPlazos({
                    plazoSelect: this.plazoSelect,
                    frecuenciaSelect: this.frecuenciaSelect,
                });
                // Visibility is data-driven (abonadoLocal.plazos &&
                // plazos_pendientes.length > 0); no flag toggle needed.
                if (!(this.abonadoLocal.plazos && Array.isArray(this.abonadoLocal.plazos_pendientes) && this.abonadoLocal.plazos_pendientes.length > 0)
                    && this.$toast && this.$toast.error) {
                    this.$toast.error('No se pudo calcular los plazos. Revisa la configuración.');
                }
            },
            getPrecioAbonado(abonado){
                var precios = this.preciosFiltered || [];

                if (abonado.penista) {
                    var penista = precios.filter(precio => precio.exclusivo_penista);
                    return penista.length > 0 ? penista : precios;
                }
                return precios.filter(precio => !precio.exclusivo_penista);
            },
            formatSeg(segundo) {
                const minutes = Math.floor(segundo / 60);
                const remainingSeconds = segundo % 60;
                return `Min: ${minutes} - Seg: ${remainingSeconds}`;
            },
            validarSegundos(segundos) {
                const params = {
                    lista_id: this.lista_id,
                    filters : {},
                    segundo_elegido: segundos
                };

                this.$store.dispatch(this.config.getVuexAlias('front.temporada.segundos.disponible'), params).then(res => {
                    this.$refs.observer.setErrors({ ['segundo_elegido']: [] });                
                }).catch(error => {
                    const errors = [];
                    errors['segundo_elegido'] = ['El segundo seleccionado no esta disponible'];
                    this.$refs.observer.setErrors(errors);
                });
            },
            volver() {
                this.paso -= 1;
            },
            close() {
                // Emit a payload so the parent can refetch the abonado list
                // only when the modal closes after a successful renovation.
                // D1 fix 2026-07-08: was emitting only modalName, parent had
                // no way to know if the modal closed on success vs cancel.
                this.$emit('close', {
                    modalName: 'renovar-' + this.abonadoLocal.id,
                    success: Boolean(this.finalizado),
                });
            },
            solicitarPlazos({ plazoSelect, frecuenciaSelect }) {
                return this.calcularPlazos({
                    n_plazos: plazoSelect,
                    frecuencia: frecuenciaSelect,
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid && this.abonadoLocal.telefono_valido) {
                    if (!this.abonadoLocal.precio.precio_total_taquilla) {
                        const precio = this.abonadoLocal.precio
                        this.abonadoLocal.precio.precio_total_taquilla = precio.price_management_interno_taquilla ? precio.precio : precio.precio + precio.price_management_taquilla;
                    }

                    this.totalConDescuento(this.abonadoLocal.precio.precio_total_taquilla, this.abonadoLocal.descuento_aplicado != 0 ? this.abonadoLocal.descuento_aplicado: this.abonadoLocal.descuento_integro);
                    if(this.listaAbonados.activar_parcelas && this.teatro.hash !== 'J1fKG9AarPuPNJ5hwY0t') {
                        this.paso = 2;
                    } else {
                        this.paso = 3;
                    }
                }
            },
            totalConDescuento(precio, descuento) {
                var desc = 0;
                if (this.abonadoLocal.descuento_aplicado != 0){
                    desc = (descuento / 100) * precio;
                }else {
                    desc = descuento;
                }
                this.total = precio - desc;
            },
            finalizarCompra() {
                const descuentosDelArea = this.abonadoLocal.area?.descuentos || [];
                const precioValido = descuentosDelArea.some(d => d.id === this.abonadoLocal.precio?.id);
                if (!precioValido) {
                    this.error = 'El precio seleccionado no pertenece al tipo de abono elegido. Por favor, revise la selección.';
                    return;
                }

                this.loading = true;
                if (this.abonadoLocal.asiento) {
                    this.abonadoLocal.asiento.zona_id = this.abonadoLocal.asiento.region_id;
                    this.abonadoLocal.asiento.asiento = this.abonadoLocal.asiento.seat;
                    this.abonadoLocal.asiento.fila = this.abonadoLocal.asiento.row;                
                }

                const params = {
                    filters: {
                        abonado_id: this.abonadoLocal.id
                    },
                    data_abonado: this.abonadoLocal,
                    metodo_pago: {
                        id: this.abonadoLocal.metodo_pago.id
                    },
                    asiento: this.abonadoLocal.asiento,
                    abonado_id: this.abonadoLocal.id,
                    precio_lista_abonado: this.abonadoLocal.area,
                    descuento_edad: this.abonadoLocal.precio,
                    descuento_aplicado: {
                        valor: this.abonadoLocal.descuento_aplicado
                    },
                    descuento_monedero: this.abonadoLocal.descuento_monedero === undefined ? 0 : parseFloat(this.abonadoLocal.descuento_monedero),
                    descuento_integro: this.abonadoLocal.descuento_integro === undefined ? 0 : this.abonadoLocal.descuento_integro,
                    parcelas_session_id: this.parcelas_session_id
                };  

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.renovar'), params).then(res => {
                    if (res.data.error) {
                        this.error = 'Error al renovar, por favor, revise los asientos';
                    } else {
                        this.finalizado = true;
                        this.mensaje = res.data.message;
                        this.url_imprimir = res.data.url_imprimir;
                        this.url_factura = res.data.url_factura;
                        this.url_parcelas = res.data.url_parcelas;
                    }

                }).catch(error => {
                    this.error = error.response.data.message;
                }).finally(() => this.loading = false);
            },
            descuentoConfirmado(descuento){
                this.abonadoLocal.descuento_monedero = descuento;
                this.totalSinDescuentoMonedero = this.total;
                this.total = this.total - descuento;
                this.isDescuentoMonedero =  false;
            },
            cancelarDescuento(){
                this.totalConDescuento(this.abonadoLocal.precio.precio_total_taquilla, this.abonadoLocal.descuento_aplicado != 0 ? this.abonadoLocal.descuento_aplicado: this.abonadoLocal.descuento_integro);
                this.totalSinDescuentoMonedero = 0;
                this.abonadoLocal.descuento_monedero = undefined;
                this.isDescuentoMonedero = false;
            },
            aplicadoDescuento(tipo) {
                switch (tipo) {
                    case 'porcentaje':
                        this.abonadoLocal.descuento_integro = 0;
                        if(this.abonadoLocal.descuento_aplicado === '0') {
                            this.disabled_descuento_integro = false;
                            this.abonadoLocal.descuento_aplicado = 0;
                        } else {
                            this.disabled_descuento_integro = true;
                        }
                        break;
                    case 'integro':
                        this.abonadoLocal.descuento_aplicado = 0;
                        if(this.abonadoLocal.descuento_integro === 0 || this.abonadoLocal.descuento_integro === '0') {
                            this.disabled_descuento_porcentaje = false;
                            this.abonadoLocal.descuento_integro = 0;
                        } else {
                            this.disabled_descuento_porcentaje = true;
                        }
                        break;
                }
            },
            borrarMetodoDePago(metodos_de_pago, id) {
                const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);

                if (metodo_pago_id !== -1) {
                    metodos_de_pago.splice(metodo_pago_id, 1);
                }
                    
                return metodos_de_pago;
            },
            cambiarAsiento() {
                this.$emit('cambiarAsiento');
            },
            borrarSesionParcelas(cart_id) {
                const params = {
                    cart_id: cart_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                    this.abonadoLocal.plazas_session_id = null;
                })
            },
            rellenarPais(pais) {
                this.pais = pais;
                this.abonadoLocal.pais = pais.nombre;
            }
        },
        components: { SaldoMonederoComponent, DatosLegales, FieldComponent, SeleccionarParcelasComponent, PhoneInput, Paises, Provincias, Locations, checkBoxRenovacion },
    }
</script>

<style scoped>
    .price-large {
        font-size: 40px !important;
        margin-bottom: 4em;
    }
    .price {
        margin-bottom: 4em;
    }
    .espacio {
        justify-content: center;
        align-items: center;
    }
    .my-auto {
        padding-top: 1em;
        padding-bottom: 1em;
        margin-top: 20em;
        font-family: 'Noway';
    }
    hr{
        width: 100%;
        height: 2px;
        margin-top: 1em;
        margin-bottom: 1em;
    }
    @media (max-width: 768px) {
        .price-large {
            font-size: 30px !important;
            margin-left: 0px;
        }
    }
</style>
